import TopExpertsChoiceLogo from './logo'
import {topExpertsChoiceStylesCA, topExpertsChoiceStylesUK} from './styles'

const baseConfig = {
  domainName: 'topexpertschoice' as const,
  domainType: 'eu' as const,
  siteName: 'Top Experts Choice',
  favicon: '/favicons/topexpertschoice.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-YW51H7TTMZ',
    camelCaseUrl: 'TopExpertsChoice.co.uk',
    logo: <TopExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="uk" />,
    title: (category: string, count: string) =>
      `Top ${count} Expert Choice ${category} in the UK | Shop Confidently with Expert Choices | TopExpertsChoice.co.uk`,
    description: (_category?: string, _count?: string) =>
      `TopExpertsChoice.co.uk – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: topExpertsChoiceStylesUK,
  },
  ca: {
    measurementId: 'G-JQF9S54N12',
    camelCaseUrl: 'TopExpertsChoice.ca',
    logo: <TopExpertsChoiceLogo className="size-10 shrink-0 tablet:size-8" locale="ca" />,
    title: (category: string, count: string) =>
      `Top ${count} Expert Choice ${category} in CA | Shop Confidently with Expert Choices | TopExpertsChoice.ca`,
    description: (_category?: string, _count?: string) =>
      `TopExpertsChoice.ca – Expert reviews on thousands of products. Discover top-rated items at today's lowest prices, all in one place!`,
    styles: topExpertsChoiceStylesCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
